// extracted by mini-css-extract-plugin
module.exports = {"menu":"_3HA094UoHBLmGJuQhv2Clw=="};